import { createContext } from "react";

import type { SafeAreaContextType } from "./types";
import { getEmptySafeAreaContext } from "./utilities";

export const SafeAreaContext = createContext<SafeAreaContextType>(getEmptySafeAreaContext());
